/**
 * Hardcoded built-in trigger apps shown in the app picker
 * (Schedule, Webhook, Forms by Workload).
 */
export const BUILT_IN_TRIGGER_PICKER_APPS = [
  {
    name: 'Schedule',
    app: 'schedule',
    icon: 'https://cms.workload.co/wp-content/uploads/2021/07/schedule.svg',
    auth: false,
    formDataEndpoint: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/schedule',
    category: 'Utility',
    trigger: true,
    action: false,
  },
  {
    name: 'Webhook',
    app: 'webhook',
    icon: 'https://cdn.workload.co/wp-content/uploads/2021/09/webhook-1.png',
    auth: false,
    formDataEndpoint: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/webhook',
    category: 'Utility',
    trigger: true,
    action: false,
  },
  {
    name: 'Forms by Workload',
    app: 'workload-forms',
    icon: 'https://cms.workload.co/wp-content/uploads/workload-forms.png',
    auth: false,
    formDataEndpoint: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/apps/workload-forms',
    category: 'Utility',
    trigger: true,
    action: false,
  },
];
